import React, { useEffect } from 'react';
import { Stack } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { ToggleElement } from "@odmonorepo/core-components";
import { PPDOption } from './PPDOption';
import { Button, FormattedMessageDiv } from '@odmonorepo/core-components';
import { useWizardContext } from '@odmonorepo/core-components';
import { getPricingDetails, toPricingRequest, useDetailedOffers } from 'merchant-api/offer';
import { disablePreview, pricedDetails } from '../../OfferConfig';
import { useSetAtom } from 'jotai';
import { useApplication } from 'merchant-api/unified';

export const PPDOptions = () => {
  const { watch } = useFormContext();
  const { goToStep } = useWizardContext();
  const setPricing = useSetAtom(pricedDetails);
  const setDisabled = useSetAtom(disablePreview)
  const { getPricingError, getPricing, getPricingSending} = getPricingDetails();
  const { offers, customerData } = useDetailedOffers();
  const { applicationData } = useApplication();
  const exampleInterest = 1000;
  const data = watch("offer");

  useEffect(() => {
    setDisabled(getPricingSending)
  }, [getPricingSending]);

  if (getPricingError) throw new Error('Error getting pricing');

  const ppdToOfferId = (ppd: number, value) => {
    const selectedOffer = offers.filter(o => o.offerId === value)[0];
    const ppdNoNulls = selectedOffer?.prePaymentDiscountPct === 100 ? 100 : 25;
    return ppdNoNulls === ppd
      ? data.offerId
      : selectedOffer?.prePaymentDiscountRelatedOfferIds[ppd.toString()];
  };

  return (
    <Stack className="shadow-none w-100 px-4 pt-4 pt-md-5 pe-md-2 ps-md-6">
      <Controller
        name="offer.offerId"
        render={({ field: { onChange, name, value } }) => (
          <Stack direction="vertical" gap={3}>
            {[100, 25].map((discount) => {
              const offerId = ppdToOfferId(discount, value)
              return <ToggleElement 
                value={offerId}
                onChange={onChange}
                name={name}
                onClick={() => getPricing(toPricingRequest({...offers.find(o => o.offerId === offerId), pricedDetails: {...offers.find(o => o.offerId === offerId)?.pricedDetails, lineAmount: data?.loanAmount, paymentFrequency: data?.paymentFrequency}}, applicationData!, customerData)).then(res =>(setPricing({...res, ppd: Number(discount)})))}
               >
                <PPDOption
                  discount={discount}
                  exampleInterest={exampleInterest}
                  selected={value === offerId || watch("offer.offerId") === offerId}
                />
              </ToggleElement>
            })}
          </Stack>
        )}
      />
      <Button
        variant="link"
        onClick={() => {
          goToStep('SIMPLE_CONFIG');
        }}
      >
        <FormattedMessageDiv
          className="fs-7 m-2"
          id="prepayment.link.selectDifferentOffer"
        />
      </Button>
    </Stack>
  );
};

export default PPDOptions;
